import {
  GET_AREA_COVERAGE_REQUEST,
  GET_AREA_COVERAGE_SUCCESS,
  GET_AREA_COVERAGE_FAILURE,
  GET_COUNTIES_REQUEST,
  GET_COUNTIES_SUCCESS,
  ADD_AREA_COVERAGE_REQUEST,
  ADD_AREA_COVERAGE_SUCCESS,
  ADD_AREA_COVERAGE_FAILURE,
  DELETE_AREA_COVERAGE_REQUEST,
  DELETE_AREA_COVERAGE_SUCCESS,
  DELETE_AREA_COVERAGE_FAILURE,
  UPDATE_AREA_COVERAGE_REQUEST,
  UPDATE_AREA_COVERAGE_SUCCESS,
  UPDATE_AREA_COVERAGE_FAILURE,
  TOGGLLE_EDIT_MODE,
  TOGGLE_ADD_NEW_ZONE,
  RESET_COUNTIES_LIST,
  SET_ERROR_MESSAGE,
  SET_COMPANY_INFO,
  GET_COVERAGE_STATE_REQUEST,
  GET_COVERAGE_STATE_SUCCESS,
  GET_STATE_COUNTIES_SUCCESS,
  GET_STATE_COUNTIES_FAILURE,
  GET_COUNTIES_FAILURE
} from './constants';
import I18n from '../../config/locales';

let initialState = {
  error: '',
  currentlySending: false,
  isLoading: false,
  zones: [],
  activeZone: {},
  defaultZone: {
    name: '',
    solar_pricing: { min: '', max: '' },
    storage_pricing: { min: '', max: '' },
    counties_covered: []
  },
  counties: [],
  formMessage: '',
  formMessageType: '',
  editMode: false,
  canAddNewZone: false,
  lastUpdatedZoneName: '',
  companyInfo: {
    solar_new_installations_attributes: {},
    solar_installation_upgrades_attributes: {},
    storage_new_installations_attributes: {},
    orphaned_systems: null
  },
  coverageState: [],
  stateCounties: []
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_AREA_COVERAGE_REQUEST:
      return { ...state, formMessage: '', formMessageType: '', currentlySending: true, error: '' };
    case GET_AREA_COVERAGE_FAILURE:
      return { ...state, error: action.error, currentlySending: false };
    case GET_AREA_COVERAGE_SUCCESS:
      return {
        ...state,
        zones: action.zones,
        formMessage: '',
        formMessageType: '',
        currentlySending: false,
        error: ''
      };
    case ADD_AREA_COVERAGE_REQUEST:
      return { ...state, formMessage: '', formMessageType: '' };
    case ADD_AREA_COVERAGE_SUCCESS:
      return {
        ...state,
        zones: action.zones,
        formMessage: I18n.t('message.serviceAreasCreateSuccess'),
        formMessageType: 'success',
        lastUpdatedZoneName: action.lastUpdatedZoneName
      };
    case ADD_AREA_COVERAGE_FAILURE:
      return { ...state, formMessage: action.formMessage, formMessageType: 'error' };
    case GET_COVERAGE_STATE_REQUEST:
      return { ...state, formMessage: '', formMessageType: '' };
    case GET_COVERAGE_STATE_SUCCESS:
      return {
        ...state,
        coverageState: action.coverageState
      };
    case DELETE_AREA_COVERAGE_REQUEST:
      return { ...state, formMessage: '', formMessageType: '' };
    case DELETE_AREA_COVERAGE_SUCCESS:
      return {
        ...state,
        zones: action.zones,
        formMessage: I18n.t('message.serviceAreasDeleteSuccess'),
        formMessageType: 'success'
      };
    case DELETE_AREA_COVERAGE_FAILURE:
      return { ...state, formMessage: action.formMessage, formMessageType: 'error' };
    case UPDATE_AREA_COVERAGE_REQUEST:
      return { ...state, formMessage: '', formMessageType: '' };
    case UPDATE_AREA_COVERAGE_SUCCESS:
      return {
        ...state,
        zones: action.zones,
        formMessage: I18n.t('message.serviceAreasUpdateSuccess'),
        formMessageType: 'success',
        lastUpdatedZoneName: action.lastUpdatedZoneName
      };
    case UPDATE_AREA_COVERAGE_FAILURE:
      return { ...state, formMessage: action.formMessage, formMessageType: 'error' };
    case TOGGLLE_EDIT_MODE:
      return { ...state, editMode: action.editMode };
    case GET_COUNTIES_REQUEST:
      return { ...state, isLoading: true };
    case GET_COUNTIES_SUCCESS:
      return { ...state, counties: action.counties, isLoading: false };
    case GET_COUNTIES_FAILURE:
      return { ...state, counties: action.counties, isLoading: false };
    case GET_STATE_COUNTIES_SUCCESS:
      return { ...state, stateCounties: action.stateCounties, isLoading: false };
    case GET_STATE_COUNTIES_FAILURE:
      return { ...state, stateCounties: action.stateCounties, isLoading: false };
    case TOGGLE_ADD_NEW_ZONE:
      return { ...state, canAddNewZone: action.canAddNewZone };
    case RESET_COUNTIES_LIST:
      return { ...state, counties: [] };
    case SET_ERROR_MESSAGE:
      return { ...state, error: action.error };
    case SET_COMPANY_INFO:
      return { ...state, companyInfo: action.companyInfo };
    default:
      return state;
  }
}

export default reducer;
